const defaultOptions = {
	params: {
		type: 'EXTERNAL',
	},
};

export default defaultOptions;